import ChatReportList from '../../containers/ChatReportList';
import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Layout } from 'antd';
import MessageFeed from '../../containers/MessageFeed';
import UserFeed from '../../containers/UserFeed';
import BannedList from '../../containers/BannedList';
import ReportList from '../../containers/ReportList';
import Dir from '../../containers/Dir';
import NavMenu from '../../components/NavMenu';
import NavBar from '../../components/NavBar';
import BannerSetting from '../../containers/BannerSetting';
import Dashboard from '../../containers/Dashboard';
// import FeaturedList from '../../containers/FeaturedList';
import CartonList from '../../containers/CartonList';
import ApplicationList from '../../containers/ApplicationList';
import WechatGroupList from '../../containers/WechatGroupList';
import ReleaseSettings from '../../containers/ReleaseSettings';
import ProfileChangeList from '../../containers/ProfileChangeList';
import './index.css';

const { Content, Footer } = Layout;

export default function HomePage() {
  return (
    <Layout className="homePage">
      <Router>
        <NavMenu />
        <Layout className="right-panel">
          <NavBar />
          <Content className="workspace">
            <Dir></Dir>
            <Switch>
              <Route path="/chat-reports/:id?" component={ChatReportList} />
              <Route path="/release-settings" component={ReleaseSettings} />
              <Route path="/dashboard" component={Dashboard} />
              <Route path="/message/:pageNum" component={MessageFeed} />
              <Route path="/profile-changes" component={ProfileChangeList} />
              <Route path="/applications" component={ApplicationList} />
              <Route path="/users/:pageNum" component={UserFeed} />
              <Route path="/banned" component={BannedList} />
              <Route path="/cartons" component={CartonList} />
              <Route path="/reports/:pageNum" component={ReportList} />
              <Route path="/banners" component={BannerSetting} />
              <Route path="/wechatgroups" component={WechatGroupList} />
              <Route path="/" exact component={MessageFeed} />
            </Switch>
          </Content>
          <Footer className="footer">
            纸条 ©2019 Created with Love, Sweat, and Tears
          </Footer>
        </Layout>
      </Router>
    </Layout>
  );
}
